import { useColorModeValue } from '@chakra-ui/react';

export const useMenuFontActiveColor = () => {
  const fontActiveColor = useColorModeValue(
    'text.light.active',
    'text.dark.active',
  );
  return { fontActiveColor };
};
